import { Component } from '@angular/core';
import { ViewController} from 'ionic-angular';
import { ApiService } from "../../services/api.service";
import {InAppBrowser} from "@ionic-native/in-app-browser";

@Component({
  selector: 'page-news-modal',
  templateUrl: 'news-modal.html',
})
export class NewsModalPage {

  loading = 0;
  data:any = [];

  constructor(
    public api: ApiService,
    public iab: InAppBrowser,
    public viewCtrl: ViewController
  ) {
    this.load();
  }

  load() {
    this.loading = 1;
    this.api.getNews().then((data) => {
      this.loading = 0;
      this.data = data;
    }).catch((error) => {
      this.loading = -1;
      console.error(error);
    });
  }

  openLink(record) {
    if(record.link){
      this.iab.create(record.link, '_system');
    }
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewsModalPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/news-modal/news-modal.ts